import React from 'react'
import PageHeading from '../Global/PageHeading'
import Editor from './Editor'
import ImgModal from '../Modals/ImgModal'

class Content extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			modal: false,
			percentage: 0,
			abortUpload: undefined
		};
		this.onModal = this.onModal.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onOverlay = this.onOverlay.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}
	
	onModal(abortUpload) {
		document.body.classList.add('modal-open');
		this.setState({
			modal: true,
			abortUpload: abortUpload
		});
	}

	onClose() {
		this.state.abortUpload()
		document.body.classList.remove('modal-open');
		this.setState({
			modal: false
		});
	}
	
	onOverlay(e) {
		if (e.target.dataset.modal) {
			this.onClose();
		}
	}
	
	onUpdate(pc) {
		this.setState({
			percentage: pc
		})
	}
	
	render() {
		
		/** PATHS: New, Draft, Published **/
		const pathObj = this.props.pathname.params.type
		const path = pathObj === 'edit' ? 'edit' : 'new'
		const report_id = this.props.pathname.params.report_id
		const type = {
			path,
			report_id: report_id
		}
		return (
			<section className="content">
				<div className="container width-x">
					<PageHeading heading={ "Trip Report" } />
					<Editor onModal={ this.onModal } onClose={ this.onClose } onUpdate={ this.onUpdate} type={ type } />
					<ImgModal percentage={ this.state.percentage } onOverlay={ this.onOverlay } onClose={ this.onClose } isOpen={ this.state.modal } transitionName="opacity" />
				</div>
			</section>
		)
	}
}

export default Content


// WEBPACK FOOTER //
// ./src/components/Editor/Content.js